import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import {
  convertBefehl34FormDataToModel,
  convertModelToBefehl34FormData
} from './converters'
import Auftrag34_10Form from './Auftrag34_10Form'
import { useBefehlForm } from '../../../hooks'
import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl34 } from '../../../models'
import { Befehl34FormData, createBefehl34FormValidationSchema } from './schema'

/**
 * Main form component for Befehl 34
 */

export default function Befehl34Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-34-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl34>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl34FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl34FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl34FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl34FormData) => {
      const updatedBefehl = convertBefehl34FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl34FormData>
      befehlKennung="34"
      title={t('befehle.34.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 34.10 */}
      <Auftrag34_10Form
        befehlKennung="34"
        fieldPrefix="auftrag_34_10"
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-34-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
